import InformationPage from './information-page.component.vue';

export { InformationPage };
